import { render, staticRenderFns } from "./EntregaDomicilioDashboard.vue?vue&type=template&id=6bee5b40&scoped=true"
import script from "./EntregaDomicilioDashboard.vue?vue&type=script&lang=js"
export * from "./EntregaDomicilioDashboard.vue?vue&type=script&lang=js"
import style0 from "./EntregaDomicilioDashboard.vue?vue&type=style&index=0&id=6bee5b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bee5b40",
  null
  
)

export default component.exports